module.exports = "<div *ngIf=\"service.show\" class=\"popup-container\">\r\n  <div (click)=\"close()\" class=\"popup-wrapper\"></div>\r\n  <div class=\"popup\">\r\n    <a class=\"close\" (click)=\"close()\">&times;</a>\r\n    <h5>Contact Carrier</h5>\r\n    <div class=\"popup-line-div\"></div>\r\n    <p><strong>Company:</strong> {{ service.company }}</p>\r\n    <p><strong>Website:</strong> {{ service.website }}</p>\r\n    <a (click)=\"close()\" class=\"btn text-center\" href=\"http://{{ service.website }}\" target=\"_blank\">Visit Website</a>\r\n  </div>\r\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/contact-carrier/contact-carrier.component.html
// module id = 954
// module chunks = 0